// Company-owned WhatsApp number (2026-07-23 strategy shift) — new lead-gen surfaces
// (FloatingWaButton, QuickConsultWidget, the article hook-questionnaire CTA) send the
// visitor here instead of exposing an individual pro's phone number. No OTP gate: this
// isn't a specific pro's private number, so the verification flow in ContactModal.tsx
// doesn't apply. lib/waMessage.ts's openWhatsApp() expects a LOCAL (0-prefixed) number
// and prepends 972 itself — pass the local form, not the already-international one.
import { openWhatsApp } from './waMessage';

export const COMPANY_PHONE_LOCAL = '0506403800';

export function openCompanyWhatsApp(message: string): void {
  openWhatsApp(COMPANY_PHONE_LOCAL, message);
}
